// Shelfology Custom: announce announcement-bar slide text after next/prev (WCAG 4.1.3).
(() => {
  const ANNOUNCE_DELAY = 200;
  const CLEAR_DELAY = 5000;

  function visibleAnnouncementText(slide) {
    if (!slide) return '';

    const nodes = Array.from(slide.querySelectorAll('.announcement-text'));
    const visible = nodes.find((node) => {
      const style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
    const source = visible || nodes[0];
    return source ? source.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function selectedSlide(bar) {
    const selected = bar.querySelector('.announcement__slide.is-selected');
    if (selected) return selected;

    if (bar.slider && bar.slider.selectedElement) {
      return bar.slider.selectedElement;
    }

    const slides = bar.querySelectorAll('.announcement__slide');
    const index = Number.isInteger(bar.selectedIndex) ? bar.selectedIndex : 0;
    return slides[index] || null;
  }

  // Flickity cell setup sets aria-hidden on every slide, then select() clears
  // the current one. If that attribute sticks, visibility:hidden removes the
  // only message from VoiceOver and the tab order. Keep the selected slide exposed.
  function syncSlideExposure(bar) {
    const selected = bar.querySelector('.announcement__slide.is-selected');
    if (!selected) return;

    bar.querySelectorAll('.announcement__slide').forEach((slide) => {
      const isSelected = slide === selected;
      if (isSelected) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');

      slide.querySelectorAll('button, [href]').forEach((control) => {
        if (isSelected) control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', '-1');
      });
    });
  }

  function bind(wrap) {
    if (wrap.hasAttribute('data-announcement-live-bound')) return;

    const bar = wrap.querySelector('announcement-bar');
    const status = wrap.querySelector('[data-announcement-live-region]');
    if (!bar || !status) return;

    wrap.setAttribute('data-announcement-live-bound', '');

    let userInitiated = false;
    let setTimer = 0;
    let clearTimer = 0;

    const markUser = () => {
      userInitiated = true;
    };

    const announce = () => {
      const message = visibleAnnouncementText(selectedSlide(bar));
      window.clearTimeout(setTimer);
      window.clearTimeout(clearTimer);
      if (!status.isConnected || !message) return;

      status.textContent = '';
      setTimer = window.setTimeout(() => {
        if (!status.isConnected) return;
        status.textContent = message;
        clearTimer = window.setTimeout(() => {
          if (status.textContent === message) status.textContent = '';
        }, CLEAR_DELAY);
      }, ANNOUNCE_DELAY);
    };

    // Capture on the wrap (ancestor of <announcement-bar>) so markUser runs
    // before the host's target slider:next/previous handlers call Flickity.
    // Capture on the host itself is AT_TARGET and would lose to init() order.
    wrap.addEventListener('slider:next', markUser, { capture: true });
    wrap.addEventListener('slider:previous', markUser, { capture: true });

    // Pause while focus is inside the bar. Hide CSS drops the focused slide as
    // soon as Flickity advances, and hover pause does not cover keyboard focus.
    // unpausePlayer resumes only a paused player, so a drag stop stays stopped.
    // Leave the explicit Pause control paused. Stay paused while the shared
    // dialog is open: focus has left the bar, but resuming would hide the trigger.
    const pauseAutoplay = () => {
      if (!bar.slider) return;
      bar.dispatchEvent(new CustomEvent('slider:pause'));
    };

    const resumeAutoplay = () => {
      if (!bar.slider || typeof bar.slider.unpausePlayer !== 'function') return;
      if (!bar.hasAttribute('autoplay')) return;
      if (wrap.querySelector('button[is="control-button"][paused]')) return;
      const dialog = document.getElementById('custom-rich-text-modal');
      if (dialog && dialog.hasAttribute('open')) return;
      bar.slider.unpausePlayer();
    };

    wrap.addEventListener('focusin', pauseAutoplay);
    wrap.addEventListener('focusout', (event) => {
      if (wrap.contains(event.relatedTarget)) return;
      resumeAutoplay();
    });

    const hookSlider = () => {
      if (!bar.slider || bar.slider._announcementLiveHooked) return;
      bar.slider._announcementLiveHooked = true;
      bar.slider.on('dragStart', markUser);
      // Flickity adds its mouseleave listener on mouseenter, after this one,
      // and unpauses in that turn. setTimeout 0 runs after that unpause.
      bar.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (wrap.contains(document.activeElement)) pauseAutoplay();
        }, 0);
      });
      if (wrap.contains(document.activeElement)) pauseAutoplay();
    };

    hookSlider();
    syncSlideExposure(bar);
    wrap.addEventListener('slider:change', () => {
      hookSlider();
      syncSlideExposure(bar);
      if (!userInitiated) return;
      userInitiated = false;
      announce();
    });

    if (!bar.querySelector('.announcement__slide.is-selected')) {
      const observer = new MutationObserver(() => {
        hookSlider();
        if (bar.querySelector('.announcement__slide.is-selected')) {
          syncSlideExposure(bar);
          observer.disconnect();
        }
      });
      observer.observe(bar, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.announcement-bar').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
